import {
  element,
  elementType,
  func,
  node,
  oneOfType,
  string,
} from "prop-types";

const Raw = ({ html, tag: Component, ...rest }) => (
  <Component {...rest} dangerouslySetInnerHTML={{ __html: html }} />
);

Raw.propTypes = {
  tag: oneOfType([element, elementType, node, func, string]),
};

Raw.defaultProps = {
  tag: "div",
};

export default Raw;
